import { MockFactory } from '@tino-frontend/mocks'

export const SnoozeDetailsErrorMock = new MockFactory<any>({
  message: 'Houve um erro parar gerar o boleto',
  status: '404',
})
